import { Action, WelcomeSentError, RedirectType } from '../types';
import { CoreApplication } from '../utilities/applications';

export interface State {
  error: WelcomeSentError | null;
  email: string;
  redirectType: RedirectType;
  showBrowserWarning: boolean;
  migratingApplications?: CoreApplication[];
}

export const defaultState = {
  error: null,
  email: '',
  redirectType: RedirectType.ResumeMigration,
  showBrowserWarning: false,
};

const welcomeSent = (state: State = defaultState, action: Action): State => {
  switch (action.type) {
    default:
      return state;
  }
};

export default welcomeSent;
